export default {
  brand: "OTOSUBS",
  tagline: "Autonomous Business Technology. Satu Perniagaan. Satu Platform. Kemungkinan Tanpa Had.",
  nav: {
    home: "Utama", products: "Produk", industries: "Industri", pricing: "Harga",
    whyUs: "Kenapa Kami", about: "Tentang Kami", contact: "Hubungi Kami",
    login: "Log Masuk", bookDemo: "Tempah Demo", startFree: "Mula Percuma", apps: "Aplikasi",
  },
  common: {
    explore: "Terokai", startFree: "Mula Percuma", bookDemo: "Tempah Demo", talkToSales: "Hubungi Jualan",
    learnMore: "Ketahui lebih", viewAll: "Lihat semua", perMonth: "/ bulan", monthly: "Bulanan", annual: "Tahunan",
    annualSaving: "Penjimatan tahunan", estimated: "Anggaran langganan bulanan", startWithPlan: "Mula Dengan Pelan Ini",
    startSubscription: "Mula Langganan", contactSales: "Hubungi Jualan", getStarted: "Mula Sekarang",
    active: "AKTIF", notSubscribed: "BELUM LANGGAN", addProduct: "Tambah Produk", whatsappSales: "WhatsApp Jualan",
    openApp: "Buka Aplikasi", comingSoon: "Pautkan aplikasi anda", recommended: "Gabungan disyorkan", features: "Ciri-ciri",
    exploreProduct: "Terokai", backToProducts: "Semua produk", backToIndustries: "Semua industri",
    demoMode: "Mod demo", mockNote: "Ini pratonton visual. Log masuk sebenar akan dilancarkan bersama platform.",
  },
  home: {
    eyebrow: "PLATFORM PERNIAGAAN MASTER",
    h1a: "Urus Seluruh Perniagaan Anda",
    h1b: "Dari Satu Platform.",
    sub1: "Satu Platform. Pelbagai Solusi Perniagaan. Dikuasakan AI.",
    sub2: "Urus pekerja, pelanggan, jualan, pemasaran, operasi, koperasi, travel, kedai dan komunikasi AI melalui satu ekosistem digital.",
    sub3: "Daripada HR dan payroll sehingga CRM, advertising, chatbot, travel management dan point-of-sale — pilih hanya sistem yang perniagaan anda perlukan.",
    exploreProducts: "Terokai Produk",
    trust: ["Berasaskan Awan", "Dikuasakan AI", "Pelbagai Syarikat", "Pelbagai Cawangan", "Selamat", "Boleh Skala", "Sedia API"],
    pillarsEyebrow: "SATU PLATFORM",
    pillarsTitle: "Semua Yang Perniagaan Anda Perlukan.",
    pillars: [
      { k: "PEKERJA", d: "Ambil, gaji dan majukan pasukan anda." },
      { k: "PELANGGAN", d: "Satu CRM merentasi semua saluran." },
      { k: "JUALAN", d: "Sebut harga, invois dan bayaran." },
      { k: "PEMASARAN", d: "Kempen AI yang menukar jualan." },
      { k: "OPERASI", d: "Projek, kelulusan, cawangan." },
      { k: "AI", d: "Pembantu untuk setiap aliran kerja." },
    ],
    ecoEyebrow: "EKOSISTEM PRODUK",
    ecoTitle: "Semua Keperluan Perniagaan Anda. Terhubung Dalam Satu Ekosistem.",
    ecoSub: "Daripada melanggan pelbagai sistem berasingan, urus perniagaan anda melalui satu platform yang terhubung.",
    flowEyebrow: "SATU EKOSISTEM",
    flowTitle: "Lebih Hebat Bersama.",
    flowSub: "Setiap produk boleh beroperasi secara berasingan. Tetapi apabila terhubung, ia menjadi lebih berkuasa.",
    flows: [
      { name: "Enjin Pertumbuhan", steps: ["ADS BOOSTER", "WASAP AI", "CRM", "PELANGGAN", "JUALAN", "BAYARAN", "BLDG OPS", "ANALITIK HASIL"] },
      { name: "Operasi Warga Kerja", steps: ["HR", "KEHADIRAN", "PAYROLL", "BLDG OPS", "KEWANGAN"] },
      { name: "Gelung Runcit", steps: ["STORE", "PELANGGAN", "CRM", "WASAP AI", "ADS", "KESETIAAN", "JUALAN BERULANG"] },
      { name: "Perjalanan Travel", steps: ["ADS", "WASAP AI", "TRAVEL CRM", "PAKEJ", "TEMPAHAN", "BAYARAN", "PELEPASAN", "KESETIAAN"] },
    ],
    accountEyebrow: "SATU AKAUN PERNIAGAAN",
    accountTitle: "Satu Log Masuk. Semua Aplikasi Perniagaan Anda.",
    accountSub: "Cipta satu akaun organisasi. Tiada lagi log masuk berasingan untuk setiap produk.",
    switcherTitle: "Beralih antara produk tanpa log masuk semula.",
    dashEyebrow: "DASHBOARD UNIVERSAL",
    dashTitle: "Perniagaan Anda. Satu Paparan.",
    dashGreeting: "SELAMAT PAGI",
    dashInsights: "WAWASAN PERNIAGAAN",
    aiEyebrow: "AI UNIVERSAL",
    aiTitle: "Kenali AI Perniagaan Anda.",
    aiSub: "Satu pembantu untuk seluruh perniagaan. Soalan disalurkan secara dalaman kepada pakar AI yang betul — HR AI, Sales AI, Marketing AI, Finance AI dan banyak lagi. AI hanya mengakses modul dan data yang anda mempunyai kebenaran.",
    aiTry: "Cuba tanya:",
    aiQuestions: [
      "Berapa sales bulan ini?",
      "Campaign mana paling untung?",
      "Berapa staff cuti hari ini?",
      "Produk mana paling laku?",
      "Branch mana paling profitable?",
    ],
    specialistsTitle: "Di Sebalik Business AI",
    autoEyebrow: "AUTOMASI AI",
    autoTitle: "Biar AI Uruskan Kerja Berulang.",
    autoItems: [
      "AI menjawab pelanggan.", "AI menapis lead.", "AI mengagihkan lead.", "AI menganalisis iklan.",
      "AI mengesan anomali payroll.", "AI menganalisis prestasi perniagaan.", "AI meringkaskan laporan.",
      "AI mengenal pasti susulan.", "AI menggubal dokumen.", "AI membantu pengurusan.",
    ],
    autoNote: "Kelulusan manusia kekal tersedia untuk keputusan sensitif.",
    builderTitle: "Pembina Automasi",
    builderWhen: "APABILA", builderIf: "JIKA", builderThen: "MAKA",
    builderEx1: { when: "Lead Baharu Tiba", cond: "Berminat dengan Produk A", then: ["Tugaskan Jurujual", "Hantar WhatsApp", "Cipta Susulan", "Maklumkan Pengurus"] },
    builderEx2: { when: "Tuntutan Pekerja > RM1,000", cond: "Sentiasa", then: ["Kelulusan Pengurus", "Kelulusan Kewangan"] },
    ccEyebrow: "PUSAT KAWALAN PERNIAGAAN",
    ccTitle: "Tindakan Utama Hari Ini.",
    ccActions: [
      "42 lead panas belum dihubungi.",
      "Inventori Produk X menghampiri paras pesanan semula.",
      "Kempen A menghasilkan penukaran berbayar lebih kuat.",
      "7 kelulusan pekerja tertangguh.",
      "Jualan Cawangan B di bawah sasaran bulanan.",
    ],
    crossTitle: "Kembangkan Platform Anda",
    crossSub: "Guna HR sahaja? Dashboard anda mencadangkan apa yang perlu ditambah seterusnya — tanpa mengganggu kerja anda.",
    crossAdd: ["Tambah Wasap AI CRM untuk automasi pelanggan.", "Tambah Building Operations untuk CRM fasiliti & operasi."],
    ctaEyebrow: "MULA SEKARANG",
    ctaTitle: "Satu Platform. Semua Yang Perniagaan Anda Perlukan Untuk Berkembang.",
    ctaSub: "Mula dengan satu solusi. Tambah lebih banyak apabila perniagaan anda berkembang. Hubungkan semuanya melalui satu platform pintar.",
  },
  productsPage: {
    eyebrow: "EKOSISTEM PRODUK",
    title: "Sembilan Produk. Satu Ekosistem.",
    sub: "Setiap produk berfungsi secara berasingan — dan menjadi lebih berkuasa apabila terhubung. Pilih hanya apa yang perniagaan anda perlukan hari ini.",
  },
  industriesPage: {
    eyebrow: "INDUSTRI",
    title: "Dibina Untuk Industri Anda.",
    sub: "Gabungan produk yang disyorkan mengikut cara industri anda sebenar berfungsi.",
  },
  builder: {
    eyebrow: "PEMBINA SOLUSI",
    title: "Beritahu Kami Tentang Perniagaan Anda",
    q1: "Apakah industri anda?",
    q2: "Berapa bilangan pekerja?",
    q3: "Apa yang anda perlukan?",
    industries: ["Travel", "Runcit", "F&B", "Koperasi", "Perkhidmatan", "Francais", "Lain-lain"],
    sizes: ["1–20", "21–50", "51–200", "201–500", "500+"],
    needs: ["HR", "Payroll", "Jualan", "CRM", "POS", "Pengiklanan", "AI Chat", "Travel", "Pengurusan Koperasi"],
    result: "STACK PERNIAGAAN YANG DISYORKAN",
    next: "Seterusnya", back: "Kembali", seeResult: "Lihat Stack Saya", restart: "Mula semula",
  },
  pricing: {
    eyebrow: "HARGA",
    title: "Mula Dengan Apa Anda Perlukan. Tambah Apabila Perniagaan Berkembang.",
    sub: "Tidak perlu membeli semuanya. Mula kecil, berkembang bila bersedia.",
    startingFrom: "Bermula dari",
    customPricing: "Harga khas",
    tiers: [
      { id: "starter", name: "STARTER", tag: "Alat perniagaan asas.", price: 199, features: ["Pengurusan Pekerja", "CRM Asas", "Dokumen", "Laporan", "Sokongan"], cta: "startFree" },
      { id: "growth", name: "GROWTH", tag: "Untuk perniagaan berkembang.", price: 499, features: ["HR", "Wasap AI CRM", "Laporan Lanjutan", "Automasi"], cta: "startFree" },
      { id: "business", name: "BUSINESS", tag: "Untuk perniagaan yang mahu automasi.", price: 999, features: ["HR & Payroll", "Building Operations", "Wasap AI CRM", "Ads Booster", "Analitik Lanjutan", "Business AI"], cta: "bookDemo" },
      { id: "enterprise", name: "ENTERPRISE", tag: "Untuk organisasi besar.", price: null, features: ["Pelbagai Syarikat", "Keselamatan Lanjutan", "SSO", "API", "Integrasi Khas", "Sokongan Khusus", "AI Khas"], cta: "contactSales" },
    ],
    builderEyebrow: "BINA PELAN SENDIRI",
    builderTitle: "Bina Stack Perniagaan Anda",
    basePlatform: "Platform Asas",
    bundlesEyebrow: "HARGA BUNDLE",
    bundlesTitle: "Bundle Industri. Jimat Terbina.",
    bundleSaving: "Penjimatan bundle",
    specialPricing: "Harga enterprise khas",
  },
  whyUs: {
    eyebrow: "KENAPA KAMI",
    title: "Kenapa Perniagaan Memilih Kami",
    items: [
      { t: "SATU PLATFORM", d: "Berhenti mengurus pelbagai langganan perisian berasingan." },
      { t: "AI TERBINA", d: "AI diintegrasikan ke dalam aliran kerja, bukan sekadar chatbot tambahan." },
      { t: "MODULAR", d: "Mula dengan satu produk. Tambah modul lain apabila perlu." },
      { t: "SATU PANGKALAN DATA PELANGGAN", d: "Maklumat pelanggan mengalir melalui aliran kerja terhubung tanpa dimasukkan berulang kali." },
      { t: "PELBAGAI SYARIKAT", d: "Urus pelbagai syarikat dari satu akaun." },
      { t: "PELBAGAI CAWANGAN", d: "Kawal HQ dan cawangan dari satu platform." },
      { t: "AUTOMASI", d: "Kurangkan kerja pentadbiran berulang." },
      { t: "ANALITIK MASA NYATA", d: "Lihat prestasi perniagaan sebaik sahaja operasi berlaku." },
      { t: "SEDIA API", d: "Hubungkan sistem luar melalui API terkawal." },
      { t: "BOLEH SKALA", d: "Dari perniagaan kecil kepada organisasi besar melalui pelan dan pilihan deployment." },
    ],
    sharedEyebrow: "PERKHIDMATAN PLATFORM DIKONGSI",
    sharedTitle: "Dibina Sekali. Dikongsi Semua.",
    sharedSub: "Keupayaan sepunya adalah perkhidmatan platform dikongsi — tidak dibina semula tujuh kali.",
    shared: ["Identity Service", "Authentication", "Tenant Service", "Company Service", "Branch Service", "Employee Service", "Customer Service", "CRM Service", "Document Service", "Approval Engine", "Notification Engine", "Billing Engine", "Subscription Engine", "Payment Service", "Audit Service", "Analytics Service", "AI Gateway", "Integration Gateway", "API Gateway"],
    crmEyebrow: "CRM UNIVERSAL",
    crmTitle: "Satu Asas Pelanggan Dikongsi.",
    crmSub: "Satu profil pelanggan — nama, telefon, sumber, kempen, pembelian, tempahan, perbualan, bayaran, nota dan nilai pelanggan. Setiap produk menambah rekod domain sendiri di atasnya.",
    commsEyebrow: "PUSAT KOMUNIKASI UNIVERSAL",
    commsTitle: "Semua Saluran. Satu Inbox.",
    commsSub: "WhatsApp, Messenger, Instagram, Website Chat, Email dan komen sosial mengalir ke satu inbox — dikuasakan AI, pasukan anda dan CRM.",
    notifEyebrow: "NOTIFIKASI UNIVERSAL",
    notifTitle: "Satu Pusat Notifikasi.",
    notifs: ["Kelulusan payroll diperlukan.", "Lead jualan baharu.", "Bayaran pelanggan diterima.", "Stok rendah.", "Kempen memerlukan perhatian.", "Tempahan travel baharu.", "Permohonan pembiayaan menunggu kelulusan."],
    marketEyebrow: "MARKETPLACE",
    marketTitle: "App Marketplace. Akan Datang.",
    marketSub: "Pasang perakaunan, e-invois, gerbang bayaran, WhatsApp, bank, e-dagang, biometrik, e-tandatangan, logistik, analitik dan aplikasi luar — aliran hasil masa depan ekosistem.",
    partnerEyebrow: "RAKAN NIAGA / PENJUAL SEMULA",
    partnerTitle: "Jual Platform. Jana Komisen Berulang.",
    partnerSub: "Rakan niaga boleh menjual aplikasi individu, bundle, platform penuh atau white label — dengan dashboard untuk lead, pelanggan, langganan, komisen, pembaharuan dan sokongan.",
    ownerEyebrow: "PEMILIK PLATFORM",
    ownerTitle: "Satu Dashboard Untuk Seluruh Platform.",
    ownerSub: "Tenant, pelanggan aktif, MRR, ARR, churn, trial, penukaran, penggunaan, AI, storan, sokongan dan hasil mengikut produk.",
  },
  about: {
    eyebrow: "TENTANG KAMI",
    title: "Membina Sistem Operasi Untuk Perniagaan Moden.",
    p1: "Kami percaya perniagaan tidak sepatutnya memerlukan pelbagai sistem berasingan untuk menjalankan operasi harian.",
    p2: "Platform kami menyatukan pekerja, pelanggan, jualan, pemasaran, operasi dan AI dalam satu ekosistem terhubung. Perniagaan boleh mula dengan alat yang diperlukan hari ini dan menambah keupayaan apabila berkembang.",
    missionTitle: "Misi Kami",
    mission: "Menjadikan teknologi perniagaan yang berkuasa mudah, terhubung dan mampu dimiliki.",
    visionTitle: "Visi Kami",
    vision: "Satu Platform Untuk Mengurus Perniagaan Anda.",
    visionSub: "Ekosistem perniagaan pintar di mana pekerja, pelanggan, jualan, pemasaran, operasi, data dan AI bekerjasama.",
    archEyebrow: "SENI BINA PLATFORM",
    archTitle: "Satu Platform Master. Tujuh Perkhidmatan Modul.",
    archSub: "Setiap modul menggunakan asas identiti, CRM, dokumen, kelulusan, analitik dan AI yang sama.",
  },
  contact: {
    eyebrow: "HUBUNGI",
    title: "Mari Transformasikan Perniagaan Anda.",
    sub: "Berminat melihat bagaimana platform ini berfungsi? Tempah demonstrasi peribadi.",
    fullName: "Nama Penuh", company: "Syarikat", email: "Emel", phone: "Telefon",
    industry: "Industri", employees: "Bilangan Pekerja", products: "Produk Diminati", message: "Mesej",
    submit: "TEMPAH DEMO SAYA", submitting: "Menghantar...",
    successTitle: "Permohonan diterima!",
    successSub: "Pasukan kami akan menghubungi anda tidak lama lagi untuk menjadualkan demo.",
    another: "Hantar permohonan lain",
    industryOptions: ["Travel", "Runcit", "F&B", "Koperasi", "PKS", "Francais", "Perkhidmatan Profesional", "Lain-lain"],
    employeeOptions: ["1–20", "21–50", "51–200", "201–500", "500+"],
    error: "Sesuatu tidak kena. Sila cuba lagi.",
  },
  auth: {
    loginTitle: "Selamat kembali", loginSub: "Satu log masuk. Semua aplikasi perniagaan anda.",
    signupTitle: "Cipta akaun perniagaan anda", signupSub: "Mula percuma. Tambah produk apabila berkembang.",
    email: "Emel kerja", password: "Kata laluan", name: "Nama penuh", company: "Nama syarikat",
    loginBtn: "Log Masuk", signupBtn: "Cipta Akaun",
    noAccount: "Belum ada akaun?", haveAccount: "Sudah ada akaun?",
    mockBtn: "Teruskan (Demo)",
  },
  chat: {
    title: "Business AI",
    sub: "Pembantu demo — jawapan skrip",
    greeting: "Hai! Saya Business AI anda. Tanya saya apa-apa tentang platform — atau tekan soalan di bawah.",
    placeholder: "Tanya tentang harga, produk...",
    quick: [
      { q: "Macam mana HR sync dengan POS?", a: "Soalan bagus! Rekod pekerja berada dalam HR SaaS. Apabila anda tambah STORE SaaS, profil pekerja yang sama menggerakkan log masuk cashier, akses POS mengikut syif dan analitik jualan setiap pekerja — satu identiti, tiada kemasukan dua kali." },
      { q: "Tunjuk penjimatan harga", a: "Beli berasingan? 7 alat berlainan biasanya melebihi RM3,000/bulan. Dengan bundle OTOSUBS anda jimat 20% serta-merta, dan bil tahunan menjimatkan 2 bulan lagi. Cuba kalkulator Bina Stack di halaman Harga!" },
      { q: "Hubungkan iklan ke CRM", a: "ADS BOOSTER menangkap lead dari Meta & Google, menolaknya ke CRM universal, dan WASAP AI menyusul di WhatsApp secara automatik. Atribusi hasil menunjukkan kempen mana menghasilkan setiap jualan." },
      { q: "Berapa sales bulan ini?", a: "Jawapan demo: Sales bulan ini RM684K — 12% lebih tinggi dari bulan lepas. Produk paling laku: Pakej Umrah VIP. (Dalam platform sebenar, Business AI menjawab dari data sebenar anda.)" },
    ],
    fallback: "Saya pembantu demo berskrip. Dalam platform sebenar, Business AI berhubung dengan data sebenar anda merentasi HR, jualan, pemasaran dan kewangan. Cuba soalan pantas, atau tempah demo untuk melihat yang sebenar!",
  },
  footer: {
    products: "PRODUK", industries: "INDUSTRI", company: "SYARIKAT", resources: "SUMBER", legal: "UNDANG-UNDANG",
    companyLinks: ["Kenapa Kami", "Hubungi", "Rakan Niaga", "Kerjaya"],
    resourceLinks: ["Pusat Bantuan", "Blog", "API", "Dokumentasi", "Status Sistem"],
    legalLinks: ["Terma", "Privasi", "PDPA", "Keselamatan", "Pemprosesan Data"],
    rights: "Hak cipta terpelihara.",
    promise: "SATU PERNIAGAAN. SATU PLATFORM. KEMUNGKINAN TANPA HAD.",
  },
  notFound: { title: "Halaman tidak dijumpai", sub: "Halaman yang anda cari tidak wujud.", back: "Kembali ke utama" },
};
